import { afterNextRender, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppBootSplashService } from '@core/boot/app-boot-splash.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent {
  private readonly bootSplash = inject(AppBootSplashService);

  constructor() {
    afterNextRender(() => {
      this.bootSplash.notifyAppRendered();
    });
  }
}
